import React, { useState, lazy } from 'react';
import { CheckIcon, StarIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export const TeamCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const teamMembers = [{
    name: 'David Chen',
    title: 'Lead Product Manager',
    yearsOfExperience: 12,
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80&fm=webp',
    domains: ['B2B SaaS', 'Fintech', 'Marketplace'],
    toolStack: ['Jira', 'Slack', 'Mixpanel', 'Figma'],
    outcomes: ['Cut MVP lead time by 38%', '+24% activation in 90 days', 'Reduced dev cycle from 6 to 2 weeks']
  }, {
    name: 'Raj Patel',
    title: 'Product Owner',
    yearsOfExperience: 8,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qxWZcnYYgxX1BNjLXRx9rs/20250811_2324_Professional_Headshot_Sample_remix_01k2e87x1der4rnts5r97eggrq_%281%29.png',
    domains: ['E-commerce', 'EdTech', 'Mobile Apps'],
    toolStack: ['Trello', 'Asana', 'Amplitude', 'Miro'],
    outcomes: ['Increased user retention by 17%', 'Streamlined backlog prioritization process', 'Launched 5 major features in 6 months']
  }, {
    name: 'Emily Kim',
    title: 'Product Manager',
    yearsOfExperience: 7,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kV2mbHD5iBFiBM56HusHZw/Gemini_Generated_Image_9l8eh69l8eh69l8e.jpg',
    domains: ['Healthcare Tech', 'Consumer Apps', 'AI/ML'],
    toolStack: ['Notion', 'Slack', 'Google Analytics', 'Sketch'],
    outcomes: ['Reduced customer support tickets by 40%', 'Improved NPS score from 32 to 58', 'Led cross-functional team of 8 engineers']
  }, {
    name: 'Tasha Johnson',
    title: 'Senior Product Manager',
    yearsOfExperience: 10,
    image: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80&fm=webp',
    domains: ['Enterprise SaaS', 'Data Analytics', 'Cybersecurity'],
    toolStack: ['Jira', 'Confluence', 'Pendo', 'InVision'],
    outcomes: ['Grew enterprise revenue by 35% YoY', 'Developed product strategy for 2-year roadmap', 'Launched 0-1 products']
  }];
  const nextSlide = () => {
    setActiveIndex(prevIndex => (prevIndex + 2) % teamMembers.length);
  };
  const prevSlide = () => {
    setActiveIndex(prevIndex => (prevIndex - 2 + teamMembers.length) % teamMembers.length);
  };
  // Helper function to get the second card index
  const getSecondCardIndex = () => {
    return (activeIndex + 1) % teamMembers.length;
  };
  return;
};